import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Form, Input, Select, Textarea } from "react-daisyui";
import { mutations, wrapMutation } from "../graphql";
import { PutBlockMutationVariables } from "../API";
import TextAreaInput from "../components/Input/TextAreaInput";

function CreateBlock({
  zoneId,
  blockId,
  isCreate,
}: {
  zoneId: string;
  blockId?: string;
  isCreate: boolean;
}) {
  const queryClient = useQueryClient();
  const putBlockMutation = useMutation(wrapMutation(mutations.putBlock), {
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries([
        "zone",
        zoneId,
        "blocks",
        data?.putBlock?.blockId,
      ]);
    },
  });
  return (
    <>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          const data = new FormData(e.target as HTMLFormElement);
          const payload = Object.fromEntries(data.entries()) as unknown;
          putBlockMutation.mutate(payload as PutBlockMutationVariables);
        }}
      >
        <Input
          type="hidden"
          name="zoneId"
          className="input input-bordered"
          value={zoneId}
        />
        <Input
          type="hidden"
          name="blockId"
          className="input input-bordered"
          value={blockId}
        />
        <div className="form-control">
          <label className="label">
            <span className="label-text">Block Type</span>
          </label>
          <Select
            name="blockType"
            required={true}
            className="input input-bordered"
          >
            <option>AccessManager</option>
            <option>Poll</option>
            <option>Geolocation</option>
            <option>InstantMessaging</option>
            <option>Announcements</option>
            <option>Content</option>
            <option>RSVP</option>
            <option>Waitlist</option>
          </Select>
        </div>
        <div className="form-control">
          <label className="label">
            <span className="label-text">Index</span>
          </label>
          <Input
            type="text"
            pattern="^[0-9]*(\.[0-9]+)?$"
            placeholder="Index order on page"
            name="index"
            required={true}
          />
        </div>
        <div className="form-control">
          <label className="label">
            <span className="label-text">Access Level (to see)</span>
          </label>
          <Select
            name="accessLevel"
            required={true}
            className="input input-bordered"
          >
            <option value="0">Public</option>
            <option value="1">Anonymous</option>
            <option value="2">Authenticated</option>
            <option value="3">Authorized</option>
          </Select>
        </div>
        <div className="form-control">
          <label className="label">
            <span className="label-text">Access Level (to interact)</span>
          </label>
          <Select
            name="writeAccessLevel"
            required={true}
            className="input input-bordered"
          >
            <option value="0">Public</option>
            <option value="1">Anonymous</option>
            <option value="2">Authenticated</option>
            <option value="3">Authorized</option>
          </Select>
        </div>
        <div className="form-control">
          <label className="label">
            <span className="label-text">Options</span>
          </label>
          <Textarea
            name="options"
            className="textarea textarea-bordered h-24"
            defaultValue={JSON.stringify({})}
          ></Textarea>
        </div>
        <div className="form-control">
          <label className="label">
            <span className="label-text">Data</span>
          </label>
          <Textarea
            name="data"
            className="textarea textarea-bordered h-24"
            defaultValue={JSON.stringify({})}
          ></Textarea>
        </div>
        <div className="form-control">
          <Input type="submit" className="btn btn-primary" value="Add Block" />
        </div>
      </Form>
    </>
  );
}

export default CreateBlock;
